// extracted by mini-css-extract-plugin
export var dateLabel = "_3q-0";
export var dateLabelError = "_3q-1";
export var fullWidth = "_3q-2";
export var smaller = "_3q-3";